import React, { useState, useEffect } from "react";
import ReactTooltip from "react-tooltip";

export default function ProductVariant({
    productVariant,
    variantType,
    variant,
    bundleLayout,
    setVariant,
    setImageToggle,
    setShowPriceFrom,
}) {
    const [backgroundColor, setBackgroundColor] = useState("");
    const [backgroundColorName, setBackgroundColorName] = useState("");
    const variantImage =
        productVariant.image &&
        productVariant.image.gatsbyImageData.images.fallback.src;

    useEffect(() => {
        const color = productVariant.variantMetafields.find(
            (field) => field.key === "color"
        );
        if (color && color.value) setBackgroundColor(color.value);

        console.log('productVariant.selectedOptions');
        console.log(productVariant.selectedOptions);

        if(productVariant.selectedOptions && productVariant.selectedOptions[0]['value'] && productVariant.selectedOptions[0]['name'] == "Color") {
            setBackgroundColorName(productVariant.selectedOptions[0]['value']);
        }
    }, [productVariant]);

    const transformVariantSizeName = (name) => {
        const splitName = name.split(" ");
        return splitName[1] === "Hours" ? `${splitName[0]}H` : splitName[0];
    };

    if(backgroundColorName) {
        return (
            <div
                className={`sm-variant-option ${ variant.storefrontId === productVariant.storefrontId ? "chosen-option" : "" } h-8`}
                style={{ background: backgroundColor }}
                data-bind={backgroundColorName}
                onClick={() => {
                    if (setImageToggle && setShowPriceFrom) {
                      setImageToggle(true);
                      setShowPriceFrom(false);
                    }
                    setVariant(productVariant);
                  }}
                role="button"
                data-tip={backgroundColorName}>
                <ReactTooltip />
                {bundleLayout && variantImage && (
                    <div className="flex items-center">
                        <div className="variant-image w-1/5">
                            <img src={productVariant.image.gatsbyImageData.images.fallback.src}
                                 alt={productVariant.image.alt}/>
                        </div>
                        <div className='text-left text-sm font-body'>
                            <div>{productVariant.title}</div>
                            <div>${productVariant.price}</div>
                        </div>
                    </div>
                )}
                {(variantType === "Size" && !bundleLayout) && transformVariantSizeName(productVariant.title)}
            </div>);
    } else {
        return (
            <div
                className={`sm-variant-option ${ variant.storefrontId === productVariant.storefrontId ? "chosen-option" : "" } h-8`}
                style={{ background: backgroundColor }}
                onClick={() => {
                    if (setImageToggle && setShowPriceFrom) {
                      setImageToggle(true);
                      setShowPriceFrom(false);
                    }
                    setVariant(productVariant);
                  }}
                role="button">
                {bundleLayout && variantImage && (
                    <div className="flex items-center">
                        <div className="variant-image w-1/5">
                            <img src={productVariant.image.gatsbyImageData.images.fallback.src}
                                 alt={productVariant.image.alt}/>
                        </div>
                        <div className='text-left text-sm font-body'>
                            <div>{productVariant.title}</div>
                            <div>${productVariant.price}</div>
                        </div>
                    </div>
                )}
                {(variantType === "Size" && !bundleLayout) && transformVariantSizeName(productVariant.title)}
            </div>
        );
    }

}
